import EmailAttachment from "@/domain/entities/emails/EmailAttachement";
import { Attachment, MailAttachment } from "@cs_teamwaydev/mailvista-sdk_react";

export const attachmentMapper = (
    attachment: MailAttachment,
    uniqueMailvistaId?: string,
): EmailAttachment =>
    new EmailAttachment({
        id: attachment.id,
        name: attachment.name,
        size: attachment.size,
        type: attachment.type,
        path: attachment.path,
        preview: attachment.preview,
        createdAt: new Date(attachment.createdAt || new Date()),
        modifiedAt: new Date(attachment.modifiedAt || new Date()),
        sentAt: attachment.sentAt ? new Date(attachment.sentAt) : undefined,
        contentId: attachment.contentId,
        isInline: attachment.isInline,
        uniqueMailvistaId,
    });

export const mapToSDKAttachment = (
    attachment: EmailAttachment,
): Attachment => ({
    contentBytes: attachment.path,
    name: attachment.name,
    contentType: attachment.type,
    size: attachment.size,
});
